<template>
  <div class="ui search" ref="search">
    <div class="ui left icon action input">
      <input
        class="prompt"
        type="text"
        :placeholder="$t('search customer')"
        :value="customer.name"
      />
      <i class="search icon"></i>
      <div class="ui red right icon button" @click="clean">
        <i class="eraser icon"></i>
      </div>
    </div>
    <template v-for="(mdl, index) in customer_modals">
      <component
        :is="mdl"
        :key="index"
        :customer="customer"
        v-on:succedded="succedded"
      ></component>
    </template>
  </div>
</template>

<script>
import { local_api, error_toast, clone } from "@/utils";
import filters from "@/filters";
import CustomerModal from "@/modules/customer/CustomerModal";

// @ is an alias to /src
export default {
  name: "CustomerSearch",
  components: {},
  props: {
    customer_in: Object,
  },
  filters: filters,
  data() {
    return {
      customer: {},
      customer_modals: [],
    };
  },
  methods: {
    clean() {
      this.$emit("clear");
      this.customer = {};
    },
    succedded(customer) {
      this.customer = customer;
      this.$emit("select_customer", customer);
    },
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.search).search({
      apiSettings: {
        action: "search customer",
        beforeXHR: function(xhr) {
          let token = vm.$session.get("token");
          if (token) {
            xhr.setRequestHeader("x-access-token", token);
          }

          return xhr;
        },
        onResponse: function(response) {
          if (!response.success) error_toast(response.error);
          else {
            var _response = {
              results: [],
            };
            response.data.map((r) => {
              _response.results.push({
                title: r.name,
                description: r.create_date,
                customer: r,
              });
            });
            _response.results.push({
              title: vm.$t("new"),
              description: vm.$t("new customer"),
              customer: "NEW",
            });
            return _response;
          }
        },
      },
      onSelect(result) {
        if (result.customer == "NEW") {
          vm.customer_modals.push(CustomerModal);
        } else {
          local_api(vm, "post", "/customer/do-get", {
            u: result.customer.uuid,
          })
            .then((response) => {
              vm.customer = response;
              vm.$emit("select_customer", response);
            })
            .catch((err) => {
              error_toast(err);
            })
            .finally(() => {
              vm.processing = false;
            });
        }
      },
    });

    if (vm.customer_in && vm.customer_in.name) {
      vm.customer = clone(vm.customer_in);
    }
  },
  watch: {},
};
</script>
